export enum MotusIconType {
  home = 'home',
  'clipboard-outline' = 'clipboard-outline',
  'home-outline' = 'home-outline',
  'car-outline' = 'car-outline',
  clipboard = 'clipboard',
  'team-outline' = 'team-outline',
  'helmet-outline' = 'helmet-outline',
  team = 'team',
  gear = 'gear',
  gps = 'gps',
  csv = 'csv',
  report = 'report',
  'report-outline' = 'report-outline',
  'gear-outline' = 'gear-outline',
  helmet = 'helmet',
  car = 'car',
  'csv-outline' = 'csv-outline',
  'personal-locked-outline' = 'personal-locked-outline',
  'personal-locked' = 'personal-locked',
  'map-outline' = 'map-outline',
  map = 'map',
  'briefcase-outline' = 'briefcase-outline',
  briefcase = 'briefcase',
  'eye-slash-outline' = 'eye-slash-outline',
  'eye-open-outline' = 'eye-open-outline',
  'warning-circle' = 'warning-circle',
  'warning-circle-outline' = 'warning-circle-outline',
  'road-outline' = 'road-outline',
  'play-outline' = 'play-outline',
  'cross-circle-outline' = 'cross-circle-outline',
  'cross-circle' = 'cross-circle',
  'check-circle-outline' = 'check-circle-outline',
  'check-circle' = 'check-circle',
  heart = 'heart',
  'heart-outline' = 'heart-outline',
  edit = 'edit',
  'edit-square' = 'edit-square',
  'play-circle-outline' = 'play-circle-outline',
  play = 'play',
  'pause-outline' = 'pause-outline',
  'rewind-outline' = 'rewind-outline',
  'close-circle' = 'close-circle',
  'risk-outline' = 'risk-outline',
  'webinar-outline' = 'webinar-outline',
  download = 'download',
  filter = 'filter',
  'filter-outline' = 'filter-outline',
  'clapperboard-outline' = 'clapperboard-outline',
  clapperboard = 'clapperboard',
  'calendar-outline' = 'calendar-outline',
  'tag-outline' = 'tag-outline',
  'merge-outline' = 'merge-outline',
  'trash-outline' = 'trash-outline',
  'warning-triangle' = 'warning-triangle',
  'location-home' = 'location-home',
  knowledge = 'knowledge',
  menu = 'menu',
  clock = 'clock',
  'clock-outline' = 'clock-outline',
  location = 'location',
  'location-outline' = 'location-outline',
  percentage = 'percentage',
  'percentage-outline' = 'percentage-outline',
  insurance = 'insurance',
  'insurance-outline' = 'insurance-outline'
}

/**
 * Names of the Motus feature icons (`svg/feature/*.svg`).
 * Add one entry per SVG, then register it in `MotusFeatureIcons.tsx`.
 */
export enum MotusFeatureIconType {
  'truck-with-clock' = 'truck-with-clock'
}
